module.exports = __webpack_public_path__ + "iPhone7-MatteBlack-landscape.png?6bc3c97bafc8bcd86ed69031a57b9bb0";